var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-block"},[_c('h2',{staticClass:"title is-size-4"},[_vm._v(_vm._s(_vm.block.headline))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)}})])}
var staticRenderFns = []

export { render, staticRenderFns }